import axiosClient from "./axiosClient";

export const mediaApi = {
  uploadImage: (formdata) => axiosClient.post("/api/media/", formdata),
  uploadProofOfPurchase: (formdata) =>
    axiosClient.post("/api/media/proof-of-purchase", formdata),
  getImageURLS: (payload) => axiosClient.post("/api/media/urls", payload),
  getImage: (payload) => axiosClient.get(`/api/media/`, payload),
};
